import OLXAutosHeader from "../../Widgets/OLXAutosHeader/OLXAutosHeader";
import StaticImageWithCTA from "../../Widgets/StaticImageWithCTA/StaticImageWithCTA";
import BookAnAppointment from "../../Widgets/BookAnAppointment/R3/BookAnAppointment";
import BookAnAppointmentR1 from "../../Widgets/BookAnAppointment/R1/BookAnAppointment";
import BookingConfirmed from "../../Widgets/BookingConfirmedWidget/BookingConfirmedWidget";
import ItemsCarousel from "../../Widgets/ItemsCarousel/ItemsCarousel";
import BrandsWidget from "../../Widgets/BrandsWidget/BrandsWidget";
import HomeInspectionSteps from "../../Widgets/BookAnAppointment/R3/HomeInspectionSteps";
import EqualWidthColumnStaticContent from "../../Widgets/EqualWidthColumnStaticContent/EqualWidthColumnStaticContent";
import ValuationFlow from "../../Widgets/ValuationFlow/ValuationFlowWidget";
import StaticImageWithCTAAndDesc from "../../Widgets/StaticImageWithCTAAndDesc/StaticImageWithCTAAndDesc";
import PriceEstimation from "../../Widgets/PriceEstimation/PriceEstimation";
import ValuationError from "../../Widgets/ValuationError/ValuationError";
import BookingConfirmedV2 from "../../Widgets/BookingConfirmedWidget/V2/BookingConfirmedWidget";
import CXELoadingWidget from "../../Widgets/CXELoadingWidget/CXELoadingWidget";
import FAQWidget from "../../Widgets/FAQWidget/FAQWidget";
import StaticItemCarousel from "../../Widgets/StaticItemCarousel/StaticItemCarousel";
import NumberPlateInputWithLink from "../../Widgets/NumberPlateInputWithLink/NumberPlateInputWithLink";
import ReviewCarousel from "../../Widgets/ReviewCarousel/ReviewCarousel";
import TabsCarousel from "../../Widgets/TabsCarousel/TabsCarousel";
import BuyEngagerWidget from "../../Widgets/BuyEngagerWidget/BuyEngagerWidget";
import LeadGenForm from "../../Widgets/LeadGenForm/LeadGenForm";
import EqualSpacedStaticContent from "../../Widgets/EqualSpacedStaticContent/EqualSpacedStaticContent";
import PageLoadingWidget from "../../Widgets/PageLoading/PageLoadingWidget";
import HomePageBundleContainer from "../../Widgets/HomePageBundleContainer/HomePageBundleContainer";
import BuyerIntentWidget from "../../Widgets/BuyerIntentWidget/BuyerIntentWidget";
import ProgressBarLine from "../../Widgets/ProgressBarLine/ProgressBarLine";
import VideoPlayer from "../../Widgets/VideoPlayer/VideoPlayer";
import { default as ImageCarousel } from "../../Widgets/CfCarouselWidget/CfCarouselWidget";
import { default as PreApprovalFlow } from "../../Widgets/CfWidget/CfWidget";
import LoanCalculator from "../../Widgets/LoanCalculator/LoanCalculator";
import StepProgress from "../../Widgets/StepProgress/StepProgress";
import SplitView from "../../Widgets/SplitView/SplitView";
import BookingConfirmedL2Q from "../../Widgets/BookingConfirmedWidget/V3/BookingConfirmedL2Q/BookingConfirmedL2Q";
import MarkdownContentWithCTA from "../../Widgets/MarkdownContentWithCTA/MarkdownContentWithCTA";
import MapWidget from "../../Widgets/Map/MapWidget";
import NewsCarousel from "../../Widgets/NewsCarousel/NewsCarousel";
export var WIDGETS_MAPPER = {
  OLXAutosHeader: OLXAutosHeader,
  StaticImageWithCTA: StaticImageWithCTA,
  BookAnAppointment: BookAnAppointment,
  BookingConfirmed: BookingConfirmed,
  BookAnAppointmentR1: BookAnAppointmentR1,
  ItemsCarousel: ItemsCarousel,
  BrandsWidget: BrandsWidget,
  HomeInspectionSteps: HomeInspectionSteps,
  EqualWidthColumnStaticContent: EqualWidthColumnStaticContent,
  ValuationFlow: ValuationFlow,
  StaticImageWithCTAAndDesc: StaticImageWithCTAAndDesc,
  PriceEstimation: PriceEstimation,
  ValuationError: ValuationError,
  BookingConfirmedV2: BookingConfirmedV2,
  CXELoadingWidget: CXELoadingWidget,
  FAQWidget: FAQWidget,
  StaticItemCarousel: StaticItemCarousel,
  ReviewCarousel: ReviewCarousel,
  TabsCarousel: TabsCarousel,
  BuyEngagerWidget: BuyEngagerWidget,
  LeadGenForm: LeadGenForm,
  NumberPlateInputWithLink: NumberPlateInputWithLink,
  LoanCalculator: LoanCalculator,
  PreApprovalFlow: PreApprovalFlow,
  EqualSpacedStaticContent: EqualSpacedStaticContent,
  PageLoadingWidget: PageLoadingWidget,
  HomePageBundleContainer: HomePageBundleContainer,
  BuyerIntentWidget: BuyerIntentWidget,
  ProgressBarLine: ProgressBarLine,
  VideoPlayer: VideoPlayer,
  ImageCarousel: ImageCarousel,
  StepProgress: StepProgress,
  SplitView: SplitView,
  BookingConfirmedL2Q: BookingConfirmedL2Q,
  MarkdownContentWithCTA: MarkdownContentWithCTA,
  MapWidget: MapWidget,
  NewsCarousel: NewsCarousel
};